import { defineMessages } from 'react-intl';

export default defineMessages({
    searchInputTitle: {
        id: 'portal.views.search-service-claim.search-input.title',
        defaultMessage: 'Search by Claim or Service'
    },
    cancelButton: {
        id: 'portal.views.search-service-claim.Button.Cancel',
        defaultMessage: 'Cancel'
    },
    searchButton: {
        id: 'portal.views.search-service-claim.Button.Search',
        defaultMessage: 'Search'
    },
    noResultsFoundAlertTitle: {
        id: 'portal.views.search-service-claim.NoResultsAlert.Title',
        defaultMessage: 'No results found'
    },
    noResultsFoundAlertMessage: {
        id: 'portal.views.search-service-claim.NoResultsAlert.Message',
        defaultMessage: 'No services were found for this search'
    },
    errorCCCommunicationAlertTitle: {
        id: 'portal.views.search-service-claim.ErrorCCAlert.Title',
        defaultMessage: 'Error querying ClaimCenter'
    }
});
